import React, { useState } from 'react';
import Modal from 'react-modal';
import { AlertTriangle, Truck, Clock,PackageCheck,Package, Router as Route, X } from 'lucide-react';
import toast from 'react-hot-toast';
import { convertMinutesToHHMM } from '../../utils/formatters';
import { useTranslation } from 'react-i18next';

const styles = {
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    borderRadius: '10px',
    border: 'none',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
    fontFamily: 'Montserrat, sans-serif',
    maxHeight: '80vh',
    overflow: 'hidden',
   
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1001,
    borderRadius: '10px',

  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #5BBCEA 0%, #2196F3 100%)',
    padding: '24px 32px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px'
  },
  content: {
    padding: '20px',
    maxHeight: 'calc(80vh - 70px)',
    overflowY: 'auto'
  },
  constraintsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
    marginBottom: '32px'
  },
  constraintSection: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  warningBox: {
    background: '#FFEBEE',
    border: '1px solid #fecaca',
    color: '#F44336',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  waypoint: {
    background: 'white',
    borderRadius: '8px',
    padding: '15px',
    marginBottom: '15px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  waypointHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  address: {
    fontSize: '16px',
    fontWeight: '500'
  },
  statusBadge: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500'
  },
  warningBox: {
    background: '#FFEBEE',
    border: '1px solid #fecaca',
    color: '#F44336',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  depot : {
    backgroundColor: '#F3F4F6',
    opacity: 0.8,
    cursor: 'not-allowed',
  },
 
  

  
};

const SimulateOptimization = ({ isOpen, onClose, onConfirm, simulation }) => {
  const [loading, setLoading] = useState(false);
  const {t} = useTranslation();
  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm();
      onClose();
    } catch (error) {
      toast.error(error.message || t("transfer_request_err"));
    } finally {
      setLoading(false);
    }
  };

  if (!simulation) return null;
   
   console.log('simulation',simulation)

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{ content: styles.modalContent , overlay : styles.modalOverlay}}
      ariaHideApp={false}
    >
      <div style={styles.header}>
        <h3 style={{ color: 'white', margin: 0 }}>{t("optimization_simulation")}</h3>
        <button 
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer'
          }}
        >
          <X size={24} />
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.constraintsContainer}>
          <div style={styles.constraintSection}>
            <div>
              <p>{t("current_total_distance")}: {simulation.totalDistance.toFixed(2)} km</p>
              <p>{t("current_total_duration")}: {convertMinutesToHHMM(simulation.totalDuration)}</p>
              <p>{t("number_of_stop_points")}: {simulation.waypoints.length}</p>
            </div>
          </div>

          
        </div>
        {simulation.waypoints.map((waypoint, index) => (
            <div 
            key={index} 
            style={{
              ...styles.waypoint,
              ...(waypoint.depot && styles.depot),
              position: 'relative'
            }}>
              {/* Badge d'état */}
               {(!waypoint.depot && (!waypoint.activeAbsolute || !waypoint.activeMission)) && (
                <div style={{
                  ...styles.statusBadge,
                  background: !waypoint.activeAbsolute ? '#FFEBEE' : '#FFF3E0',
                  color: !waypoint.activeAbsolute ? '#F44336' : '#FF9800'
                }}>
                  <AlertTriangle size={14} />
                  {!waypoint.activeAbsolute ? 'Limite absolue' : 'Limite mission'}
                </div>
              )} 

              {/* En-tête du point */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {waypoint.depot && (
                    <Truck size={20} color="#6B7280"  />
                  ) }
                  <h3 style={{ margin: 0, fontSize: '16px',fontStyle: waypoint.depot ? 'italic' : 'normal'  }}>{waypoint.adresse.label}</h3>
                </div>
               
              </div>

              {/* Détails du point */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
                marginTop: '16px'
              }}>
               <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', fontSize: '14px' }}>
                <span>Distance :</span>
                <span style={{ fontWeight: '600', color: '#1f2937' }}>
               {waypoint.distance.toFixed(2)} km
                </span>
               </div>
               <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', fontSize: '14px' }}>
                <span>{t("duration")} :</span>
              <div style={{ padding: '8px 0' }}>
              {waypoint.depot ? (
               waypoint.position === 1 ? (
              // Premier dépôt - Chargement
             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
             <Package size={18} color="#51C7F2" />
            <div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>{t("loading")}</div>
          <div style={{ fontWeight: '600', color: '#1f2937' }}>
            {convertMinutesToHHMM(waypoint.dureeChargement)}
          </div>
        </div>
      </div>
    ) : (
      // Dernier dépôt - Déchargement
      <div style={{ display: 'grid', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Truck size={16} color="#51C7F2" />
          <div>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>{t("driving")}</div>
            <div style={{ fontWeight: '600', color: '#1f2937' }}>
              {convertMinutesToHHMM(waypoint.dureeConduite)}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <PackageCheck size={18} color="#51C7F2" />
          <div>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>{t("loading")}</div>
            <div style={{ fontWeight: '600', color: '#1f2937' }}>
              {convertMinutesToHHMM(waypoint.dureeChargement)}
            </div>
          </div>
        </div>
      </div>
    )
  ) : (
    // Points intermédiaires
    <div style={{ display: 'grid', gap: '12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Truck size={16} color="#51C7F2" />
        <div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>{t("driving")}</div>
          <div style={{ fontWeight: '600', color: '#1f2937' }}>
            {convertMinutesToHHMM(waypoint.dureeConduite)}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Clock size={16} color="#51C7F2" />
        <div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>{t("loading")}</div>
          <div style={{ fontWeight: '600', color: '#1f2937' }}>
            {convertMinutesToHHMM(waypoint.dureeChargement)}
          </div>
        </div>
      </div>
    </div>
  )}
</div>

               </div>
               <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', fontSize: '14px' }}>
                <span>Position :</span>
                <span style={{ fontWeight: '600', color: '#1f2937' }}>
                {waypoint.position} 
                </span>
               </div>
              
              
              </div>

             
            </div>
          ))}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
          marginTop: '20px',
          padding: '16px',
          borderTop: '1px solid #e5e7eb'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              background: '#e5e7eb',
              color: '#374151',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            {t("cancel")}
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '10px 20px',
              background: '#51C7F2',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? `${t("optimization")}...` : t("confirm_optimization")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SimulateOptimization;